module.exports = {"TXTCLI_City":{"id":"TXTCLI_City","defaultMessage":"Stad","flags":["TRACK"],"track":"City"}}